// @ts-nocheck
import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Grid,
  Container,
  Paper,
  Tooltip,
  InputBase,
  IconButton,
  ClickAwayListener,
  Stack,
  Badge,
  styled,
} from "@mui/material";
import "reactjs-popup/dist/index.css";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom";
import { useTheme } from "../../ThemeContext/ThemeContext.js";
import {
  BodyLarge,
  BodyMedium,
  BodySmall,
  H7TitleLarge,
  H8TitleMedium,
} from "../../components/StyledComponents/Typography/Typography.tsx";
import { PoolsPageContextProvider } from "../../Pools/context/PoolsPageContextProvider.js";
import PageWrapper from "../../components/PageWrapper/PageWrapper.js";
import DataGrid from "../../components/DataGrid/DataGrid.tsx";
import { StyledMenu, StyledMenuItem } from "../../components/StyledComponents/Menu/Menu.tsx";
import { useAuth0 } from "@auth0/auth0-react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import {
  QueryClientProvider,
  QueryClient,
  useInfiniteQuery,
} from "@tanstack/react-query";
import AuradineErrorState from "../../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import StyledLinearProgress from "../../components/StyledComponents/Progress/Progress.js";
import { useQuery } from "@tanstack/react-query";
import { GetUserUseQuery } from "../../api/api.js";
import { StyledIconButton } from "../../components/StyledComponents/Buttons/AuradineButtons.js";
import { OutlinedButton } from "../../components/StyledComponents/Buttons/AuradineButtons.js";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  PostJobDetailsByID,
  PostJobInfoByID,
} from "../../api/api.js";
import { capitalizeString } from "../../components/util.js";
import { format, parseISO, isValid } from "date-fns";
import { debounce, isEmpty } from "lodash";
import { PostAllSitesList } from "../../api/api.js";
import { render } from "@testing-library/react";
import { SecondaryButton } from "../../components/StyledComponents/Buttons/AuradineButtons.js";

const CustomBadge = styled(Badge)(({ colors }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: colors?.primary?.main,
    color: colors?.primary?.contrastText,
    fontSize: "0.75rem", // Optional: Adjust font size
    padding: "0.25rem", // Optional: Adjust padding
  },
}));

const queryClient = new QueryClient();

export const HeaderContainer = React.memo((props) => {
  const { data } = props;
  const navigate = useHistory();
  const { colors } = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={2.48}
      marginBottom={"1.5rem"}
    >
      <Box
        display="flex"
        flexDirection="column"
        minWidth={"2.98rem"}
        justifyContent="flex-start"
        alignItems={"center"}
      >
        <StyledIconButton colors={colors}
          onClick={() => {
            navigate.goBack();
          }}
        >
          {" "}
          <ArrowBackIosNewIcon
            fontSize="medium"

          />{" "}
        </StyledIconButton>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        gap={4}
        justifyContent="flex-start"
      >
        <H7TitleLarge>Job Details</H7TitleLarge>
        <BodyLarge>
          View the details of a particular job and its
          assigned miners.
        </BodyLarge>
      </Box>
    </Box>
  );
});

const IndividualJobsPageHeader = (props) => {
  const {
    selectedGroups,
    setSelectedGroups,
    siteGroups,
    onSearchChange,
    searchValue,
    setSearchValue,
    setDsearchValue,
  } = props;
  const [anchorElGroup, setAnchorElGroup] = useState(null);
  const buttonRefGroup = React.useRef(null);
  const badgeContent = selectedGroups
    ? selectedGroups.length
    : null;
  const { colors } = useTheme();
  const handleClickAwayGroup = () => {
    setAnchorElGroup(null);
  };

  const setMenuOpenGroup = () => {
    setAnchorElGroup(buttonRefGroup.current);
  };

  const toggleGroupSelection = (groupValue) => {
    setSelectedGroups((currentSelectedGroups) => {
      const updatedGroups = currentSelectedGroups.includes(
        groupValue
      )
        ? currentSelectedGroups.filter(
            (group) => group !== groupValue
          )
        : [...currentSelectedGroups, groupValue];

      const url = new URL(window.location.href);
      url.searchParams.delete("groups");
      updatedGroups.forEach((status) => {
        url.searchParams.append("groups", status);
      });
      window.history.replaceState({}, "", url.toString());
      return updatedGroups;
    });
  };

  const groupList = siteGroups.map((item) => ({
    label: item,
    value: item,
  }));

  const handleClearFilters = () => {
    setSearchValue("");
    setDsearchValue("");
    setSelectedGroups([]);
    const url = new URL(window.location.href);
    const jobID = url.searchParams.get("jobID");
    url.search = "";
    if (jobID) url.searchParams.set("jobID", jobID);
    window.history.replaceState({}, "", url);
  };

  return (
    <Box
      display="flex"
      justifyContent={"space-between"}
      alignItems="center"
    >
      <Box
        display="flex"
        justifyContent={"flex-start"}
        gap={6}
        sx={{ height: "100%" }}
      >
        <Paper
          component="form"
          elevation={0}
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            alignItems: "center",
              backgroundColor: colors?.background?.secondary,
            borderRadius: "1.75rem",
            paddingLeft: "1rem",
            width: "100%",
            height: "100%",
          }}
        >
          <Tooltip
            disableFocusListener
            disableTouchListener
          >
            <InputBase
              sx={{ flex: 1, width: "22.5rem", color: colors?.text?.primary }}
              value={searchValue}
              placeholder="Search"
              onChange={(event) => {
                const userInput = event.target.value;
                onSearchChange(userInput);
                const url = new URL(window.location.href);
                if (userInput === "") {
                  url.searchParams.delete("search");
                } else {
                  url.searchParams.set("search", userInput);
                }
                window.history.replaceState(
                  {},
                  "",
                  url.toString()
                );
              }}
              inputProps={{
                "aria-label": "search",
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                }
              }}
            />
          </Tooltip>
          <StyledIconButton colors={colors} disabled aria-label="search">
            <SearchIcon />
          </StyledIconButton>
        </Paper>
        <Box
          display="flex"
          flexDirection={"row"}
          gap={6}
          alignItems={"center"}
        >
          <ClickAwayListener
            onClickAway={handleClickAwayGroup}
          >
            <>
              <CustomBadge badgeContent={badgeContent} colors={colors}>
                <OutlinedButton
                  colors={colors}
                  onClick={setMenuOpenGroup}
                  endIcon={
                    Boolean(anchorElGroup) ? (
                      <KeyboardArrowUpRoundedIcon />
                    ) : (
                      <KeyboardArrowDownRoundedIcon />
                    )
                  }
                  ref={buttonRefGroup}
                >
                  Groups
                </OutlinedButton>
              </CustomBadge>

              <StyledMenu
                colors={colors}
                anchorEl={anchorElGroup}
                open={Boolean(anchorElGroup)}
                onClose={handleClickAwayGroup}
              >
                {groupList &&
                  groupList.map((group, index) => (
                    <StyledMenuItem
                      key={`menuItem${index}`}
                      colors={colors}
                      selected={selectedGroups.includes(
                        group.value
                      )}
                      onClick={() => {
                        if (
                          !selectedGroups.includes(
                            group.value
                          )
                        ) {
                          toggleGroupSelection(group.value);
                        }
                      }}
                      sx={{
                        minWidth: "12rem",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {group.label}
                      {selectedGroups.includes(
                        group.value
                      ) && (
                        <CloseIcon
                          fontSize="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleGroupSelection(
                              group.value
                            );
                          }}
                          style={{ cursor: "pointer" }}
                          sx={{ color: colors?.text?.muted }}
                        />
                      )}
                    </StyledMenuItem>
                  ))}
              </StyledMenu>
            </>
          </ClickAwayListener>
        </Box>
      </Box>
      <Box display="flex" paddingLeft={"2rem"}>
        <SecondaryButton colors={colors} onClick={handleClearFilters}>
          Clear Filters
        </SecondaryButton>
      </Box>
    </Box>
  );
};

/**
 * Represents the Individual Jobs  component.
 * This component displays a detials about a particular job and the miners it is assigned to.
 */
function IndividualJobsPageContent() {
  const { colors } = useTheme();
  const tableContainerRef = React.useRef(null);
  const [infoDataUpdateCount, setInfoDataUpdateCount] =
    useState(0);
  const [
    detailsDataUpdateCount,
    setDetailsDataUpdateCount,
  ] = useState(0);
  const [authToken, setAuthToken] = useState("");
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const [totalCount, setTotalCount] = useState("");
  const [selectedGroups, setSelectedGroups] = useState("");
  const urlParams = new URLSearchParams(
    window.location.search
  );
  const jobIDfromURL = urlParams.get("jobID");
  let trimmedJobID = jobIDfromURL
    ? jobIDfromURL?.trim()
    : "";
  const [searchValue, setSearchValue] = useState("");
  const [dsearchValue, setDsearchValue] = useState("");

  const debouncedSearch = useMemo(
    () =>
      debounce((userInput) => {
        setDsearchValue(userInput);
      }, 750),
    []
  );

  const onSearchChange = (userInput) => {
    setSearchValue(userInput);
    debouncedSearch(userInput);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(
      window.location.search
    );
    const groupsfromURL = urlParams.getAll("groups");
    const searchfromURL = urlParams.get("search");
    if (
      Array.isArray(groupsfromURL) &&
      groupsfromURL.length > 0
    ) {
      setSelectedGroups(groupsfromURL);
    }
    if (searchfromURL) {
      setSearchValue(searchfromURL);
      debouncedSearch(searchfromURL);
    }
  }, []);

  const {
    data: userInfo,
    isFetched: isUserInfoFetched,
    isFetching: isUserInfoFetching,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => GetUserUseQuery(authToken),
    enabled: !!authToken,
  });

  const userRole = useMemo(() => {
    return isUserInfoFetched
      ? userInfo?.user?.role || ""
      : "";
  }, [isUserInfoFetched, userInfo]);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const {
    data: infoData,
    status: statusInfo,
    isFetched: isFetchedInfo,
    refetch: jobsInfoRefetch,
    isRefetching: isJobsInfoRefetching,
    isFetching: isJobsInfoFetching,
    isLoading: isJobsInfoLoading,
    isError: isJobsInfoError,
  } = useQuery({
    queryKey: ["JobsInfo", trimmedJobID],
    queryFn: () =>
      PostJobInfoByID({
        token: authToken,
        body: {
          jobid: trimmedJobID,
        },
      }).then((res) => {
        return res;
      }),
    enabled: !!authToken && !!trimmedJobID,
  });

  let infoJobData = {};
  if (infoData && infoData.msg) {
    infoJobData =
      isFetchedInfo && infoData.msg ? infoData.msg : [];
  }

  let limit = 25;

  const {
    data: detailsData,
    fetchNextPage: fetchNextPageDetails,
    isFetchingNextPage: isFetchingNextPageDetails,
    status: statusDetails,
    isFetched: isFetchedDetails,
    refetch: jobsDetailsRefetch,
    isRefetching: isJobsDetailsRefetching,
    isFetching: isJobsDetailsFetching,
    isLoading: isJobsDetailsLoading,
    isError: isJobsDetailsError,
  } = useInfiniteQuery({
    queryKey: [
      "Jobs",
      trimmedJobID,
      dsearchValue,
      selectedGroups,
    ],
    queryFn: ({ pageParam = { skip: 0, limit } }) =>
      PostJobDetailsByID({
        token: authToken,
        body: {
          pagination: { ...pageParam },
          jobid: trimmedJobID,
          filter: {
            ...(dsearchValue !== ""
              ? { key: dsearchValue }
              : {}),
            ...(selectedGroups.length !== 0
              ? { dgnames: selectedGroups }
              : {}),
          },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        setDetailsDataUpdateCount(
          (prevCount) => prevCount + 1
        );
        return res;
      }),
    enabled: !!authToken && !!trimmedJobID,
    refetchInterval: (query) => {
      if (detailsDataUpdateCount < 3) {
        return 3000;
      } else {
        return false;
      }
    },
    staleTime: 0,
    gcTime: 0,
    initialPageParam: { skip: 0, limit },
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.flatMap(
        (page) => page.docs
      ).length;
      const totalCount = lastPage?.count || 0;
      return totalFetched >= totalCount
        ? undefined
        : { skip: totalFetched, limit };
    },
  });

  let tableData = [];
  if (
    detailsData &&
    detailsData.pages &&
    detailsData.pages.length > 0
  ) {
    tableData = isFetchedDetails
      ? detailsData.pages
          .filter((page) => page.docs)
          .flatMap((page, pageIndex) =>
            page.docs.map((item, index) => {
              // Generate a unique ID by combining the page index and the item index
              return {
                ...item,
                id: `${pageIndex}-${index}`,
              };
            })
          )
          .map((row) => {
            if (
              row?.deviceInfo &&
              typeof row.deviceInfo === "object"
            ) {
              const { deviceInfo, ...rest } = row;
              return { ...rest, ...deviceInfo };
            } else {
              const { deviceInfo, ...rest } = row;
              return rest;
            }
          })
      : [];
  }

  const {
    data: groupsData,
    isFetched: isFetchedGroups,
    refetch: GroupsRefetch,
    isRefetching: isGroupsRefetching,
    isFetching: isGroupsFetching,
    isLoading: isGroupsLoading,
    isError: isGroupsError,
  } = useQuery({
    queryKey: ["GroupsInfo"],
    queryFn: () =>
      PostAllSitesList({
        token: authToken,
        body: {
          filter: {
            siteName: infoJobData.siteName,
          },
        },
      }).then((res) => {
        return res;
      }),
    enabled: !!infoJobData.siteName && !!authToken,
  });

  let siteGroups = [];
  if (groupsData && groupsData.siteList) {
    if (
      groupsData.siteList[0].siteName &&
      groupsData.siteList[0].siteName ===
        infoJobData?.siteName &&
      groupsData.siteList[0].groups &&
      groupsData.siteList[0].groups.length !== 0
    ) {
      groupsData.siteList[0].groups.map((group) =>
        siteGroups.push(group.DGName)
      );
    }
  }

  const displayTS = (updatedAt) => {
    const parsedDate = parseISO(updatedAt);
    if (isValid(parsedDate)) {
      return format(parsedDate, "MM/dd/yyyy, h:mm a");
    } else {
      return "";
    }
  };

  function renderKeyValue(key, value, level = 0) {
    const indentStyle = {
      marginLeft: level * 6,
      color: "white",
      padding: "2px",
    };

    function renderArray(key, arr, level) {
      return (
        <div key={key} style={{ marginLeft: (level + 3) * 8 }}>
          <BodySmall sx={{ color: "white", p: "2px" }}>
            {capitalizeString(key)}:
          </BodySmall>
          {arr.map((item, index) => (
            <div key={index} style={{ marginLeft: 8 }}>
              {typeof item === "object" && item !== null
                ? Object.entries(item).map(([subKey, subVal]) =>
                    subKey !== "id"
                      ? renderKeyValue(subKey, subVal, level + 1)
                      : null
                  )
                : renderKeyValue("", item, level + 1)}
              {arr.length > 1 && index < arr.length - 1 && (
                <BodySmall sx={{ color: "white", marginLeft: 7  }}>---</BodySmall>
              )}
            </div>
          ))}
        </div>
      );
    }

    if (value && typeof value === "object" && !Array.isArray(value)) {
      return (
        <div key={key} style={{ marginLeft: level * 8 }}>
          {!["user", "email", "id"].includes(key) && (
            <BodySmall sx={{ color: "white", p: "2px" }}>
              {capitalizeString(key)}:
            </BodySmall>
          )}

          {Object.entries(value).map(([nestedKey, nestedValue]) => {
            if (["user", "email", "id"].includes(nestedKey)) return null;

            if (Array.isArray(nestedValue) && nestedValue.length > 0) {
              return renderArray(nestedKey, nestedValue, level);
            }

            if (nestedValue && typeof nestedValue === "object") {
              return (
                <div
                  key={nestedKey}
                  style={{ marginLeft: (level + 3) * 8 }}
                >
                  <BodySmall sx={{ color: "white", p: "2px" }}>
                    {capitalizeString(nestedKey)}:
                  </BodySmall>
                  {Object.entries(nestedValue).map(([subKey, subVal]) =>
                    subKey !== "id"
                      ? renderKeyValue(subKey, subVal, level + 1)
                      : null
                  )}
                </div>
              );
            }

            return renderKeyValue(nestedKey, String(nestedValue), level + 1);
          })}
        </div>
      );
    }

    if (!["user", "email", "id"].includes(key)) {
      if (["start_time", "end_time"].includes(key)) {
        return (
          <BodySmall key={key} sx={indentStyle}>
            {capitalizeString(key)}: {displayTS(value)}
          </BodySmall>
        );
      }
      return (
        <BodySmall key={key} sx={indentStyle}>
          {capitalizeString(key)}: {String(value)}
        </BodySmall>
      );
    }

    return null;
  }

  const columns = [
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "SerialNo",
      headerName: "Control Board Serial Number",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "ChassisSerialNo",
      headerName: "Chassis Serial Number",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "ip",
      headerName: "IP Address",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const value = params.value;
        return value ? (
          <a
            href={`https://${value}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              cursor: "pointer",
              textDecoration: "underline", // force underline
              color: colors?.text?.primary,
              textDecorationColor: colors?.text?.primary,
            }}
          >
            {value}
          </a>
        ) : (
          ""
        );
      },
    },
    {
      field: "model",
      headerName: "Model",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "response",
      headerName: "Response",
      flex: 1.5,
      minWidth: 200,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <BodyMedium>
            {params.value ? displayTS(params.value) : ""}
          </BodyMedium>
        );
      },
    },
    {
      field: "DGName",
      headerName: "Group",
      flex: 1,
      minWidth: 200,
    },
  ];

  const CustomGridRowsOverlay = () => {
    if (
      tableData.length === 0 &&
      isFetchedDetails &&
      detailsData &&
      detailsData.pages &&
      Array.isArray(detailsData.pages) &&
      detailsData.pages.length > 0 &&
      detailsData.pages[0].status === "ok"
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          No data available
        </Box>
      );
    }
    if (
      isJobsDetailsError ||
      (isFetchedDetails &&
        detailsData.pages &&
        Array.isArray(detailsData.pages) &&
        detailsData.pages.length > 0 &&
        detailsData.pages[0].status.toLowerCase() ===
          "error")
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: "#6B7280", // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          <AuradineErrorState message="Oops!! Something went wrong!!" />
        </Box>
      );
    }
  };

  const handleScrollEnd = () => {
    if (!isFetchingNextPageDetails) {
      fetchNextPageDetails();
    }
  };

  const dataGridProps = {
    rows: Array.isArray(tableData) ? tableData : [],
    columns,
    disableColumnMenu: true,
    hideFooterPagination: true,
    hideFooter: true,
    loading:
      isJobsDetailsFetching ||
      isJobsDetailsLoading ||
      isJobsDetailsRefetching ||
      isFetchingNextPageDetails,
    disableSelectionOnClick: true,
    disableCellSelection: true,
    overlayNoRowsTemplate: "No data available",
    paginationMode: "client",
    pagination: true,
    paginationModel: {
      page: 0,
      pageSize: Number(totalCount) || 0,
    },
    onPaginationModelChange: (model) =>
      console.log("Page changed:", model),
    onRowsScrollEnd: handleScrollEnd,
    slots: {
      loadingOverlay: () => <StyledLinearProgress colors={colors} />,
      noRowsOverlay: CustomGridRowsOverlay,
    },
    slotProps: {
      loadingOverlay: {
        variant: "linear-progress",
        noRowsVariant: "skeleton",
        sx: {
          backgroundColor: colors.background.paper,
        },
      },
    },
    getRowHeight: () => "auto",
  };

  function getLabelByValue(value) {
    let commandvalue = "";
    if (
      typeof value === "object" &&
      Object.keys(value).length > 0
    ) {
      let cmd = value;
      let command = cmd.command;
      if (command === "fvmode") {
        if ("fansInStandby" in cmd) {
          if (cmd.fansInStandby === "on") {
            commandvalue = "Standby On";
          } else if (cmd.fansInStandby === "off") {
            commandvalue = "Standby Off";
          }
        } else if ("mode" in cmd) {
          if (cmd.mode === "eco") {
            commandvalue = "Eco";
          } else if (cmd.mode === "turbo") {
            commandvalue = "Turbo";
          } else if (cmd.mode === "custom") {
            if ("tune" in cmd) {
              if (cmd.tune === "ths") {
                commandvalue = "Custom THs";
              } else if (cmd.tune === "jth") {
                commandvalue = "Custom Jth";
              } else if (cmd.tune === "autotune_v2") {
                commandvalue = "AutoTune";
              } else if (cmd.tune === "power") {
                commandvalue = "Custom Power";
              }
            }
          }
        } else if ("optimizeEco" in cmd) {
          if (cmd.optimizeEco === "on") {
            commandvalue = "Optimize Eco On";
          } else if (cmd.optimizeEco === "off") {
            commandvalue = "Optimize Eco Off";
          }
        } else if ("reTuneTime" in cmd) {
          commandvalue = "Retune";
        } else if ("miningIfNetDown" in cmd) {
          if (cmd.miningIfNetDown === "on") {
            commandvalue = "Mining w/o Internet On";
          } else if (cmd.miningIfNetDown === "off") {
            commandvalue = "Mining w/o Internet Off";
          }
        } else if ("sleep" in cmd) {
          if (cmd.sleep === "on") {
            commandvalue = "Standby On";
          } else if (cmd.sleep === "off") {
            commandvalue = "Standby Off";
          }
        } else if ("persistStandby" in cmd) {
          if (cmd.persistStandby === "on") {
            commandvalue = "Persist Standby On";
          } else if (cmd.persistStandby === "off") {
            commandvalue = "Persist Standby Off";
          }
        } else if ("leakDetected" in cmd) {
          if (cmd.leakDetected === "on") {
            commandvalue = "Leak Detection On";
          } else if (cmd.leakDetected === "off") {
            commandvalue = "Leak Detection Off";
          }
        }
      } else if (command === "accept-remote-tuning") {
        if ("parameter" in cmd) {
          if (cmd.parameter === "on") {
            commandvalue = "FluxVision Tuning On";
          } else if (cmd.parameter === "off") {
            commandvalue = "FluxVision Tuning Off";
          }
        }
      } else if (command === "led") {
        if ("code" in cmd) {
          if (cmd.code === 102) {
            commandvalue = "Flash LED On";
          } else if (cmd.code === 2) {
            commandvalue = "Flash LED Off";
          }
        }
      } else if (command === "rolling-firmware-upgrade") {
        if ("operation" in cmd) {
          if (cmd.operation === "add") {
            commandvalue = "Rolling Upgrade";
          } else if (cmd.operation === "cancel") {
            commandvalue = "Stop Rolling Upgrade";
          } else if (cmd.operation === "modify") {
            commandvalue = "Modify Rolling Upgrade";
          }
        }
      } else if (command === "powercurtail") {
        if ("operation" in cmd) {
          if (cmd.operation === "add") {
            commandvalue = "Add Power Curtail";
          } else if (cmd.operation === "delete") {
            commandvalue = "Delete Power Curtail";
          }
        }
      } else if (command === "firmware-upgrade") {
        commandvalue = "Firmware Upgrade";
      } else if (command === "fluxvisionconfig") {
        commandvalue = "Pool Config";
      } else if (command === "restart") {
        commandvalue = "Restart";
      } else if (command === "exitpcschedule") {
        commandvalue = "Reset Curtail Schedules";
      } else if (command === "reimage") {
        commandvalue = "Recover Boot Partition";
      } else if (command === "factory-reset") {
        commandvalue = "Factory Reset";
      } else if (command === "demandResponseQuery") {
        commandvalue = "QSE Query";
      } else {
        commandvalue = command;
      }
    }
    return commandvalue;
  }

  return (
    <PageWrapper>
      <HeaderContainer />
      <Grid
        container
        className={"miner-page-table-container"}
        display={"flex"}
        flexDirection={"row"}
        spacing={3}
        sx={{ transition: "all 0.3s ease-in-out" }}
      >
        <Grid
          ref={tableContainerRef}
          item
          xs={12}
          sx={{
            transition: "width 0.3s ease-in-out", // Smooth transition for width
          }}
        >
          <Box
            className={"miner-page-table"}
            display={"flex"}
            flexDirection={"row"}
            backgroundColor={colors?.background?.paper}
            padding={"0.75rem 0 0.75rem 0"}
            borderRadius={"1rem"}
            sx={{
              transition: "width 0.3s ease-in-out", // Smooth transition for width
            }}
          >
            <Box
              className={"information-container"}
              display={"flex"}
              flexDirection={"column"}
              padding={"0 0.75rem 0 0.75rem"}
              height={"auto"}
              // overflow={"auto"}
              minWidth={"0"}
              gap={4}
              flex={3}
              flexShrink={1}
            >
              <Grid container spacing={4}>
                <Grid
                  item
                  xs={6}
                  sm={3.5}
                  md={2}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    flexDirection={"column"}
                    spacing={3}
                    display={"flex"}
                    alignItems={"flex-start"}
                  >
                    <H8TitleMedium>Job ID</H8TitleMedium>
                    <BodyMedium>
                      {trimmedJobID
                        ? trimmedJobID
                        : infoJobData && infoJobData.jobID
                        ? infoJobData.jobID
                        : "No Job ID"}
                    </BodyMedium>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3.5}
                  md={2}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    flexDirection={"column"}
                    display={"flex"}
                    alignItems={"flex-start"}
                  >
                    <H8TitleMedium>
                      Created At
                    </H8TitleMedium>
                    <BodyMedium>
                      {infoJobData && infoJobData.createdAt
                        ? displayTS(infoJobData.createdAt)
                        : ""}
                    </BodyMedium>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3.5}
                  md={2}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    flexDirection={"column"}
                    display={"flex"}
                    alignItems={"flex-start"}
                  >
                    <H8TitleMedium>
                      Updated At
                    </H8TitleMedium>
                    <BodyMedium>
                      {infoJobData && infoJobData.updatedAt
                        ? displayTS(infoJobData.updatedAt)
                        : ""}
                    </BodyMedium>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3.5}
                  md={2}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    flexDirection={"column"}
                    display={"flex"}
                    alignItems={"flex-start"}
                  >
                    <H8TitleMedium>Command</H8TitleMedium>
                    {infoJobData &&
                      infoJobData.commands && (
                        <Box
                          display="flex"
                          alignItems={"center"}
                        >
                          <BodyMedium>
                            {infoJobData.commands[0]
                              ? getLabelByValue(
                                  infoJobData.commands[0]
                                )
                              : ""}
                          </BodyMedium>
                          <Tooltip
                            title={
                              infoJobData?.commands?.[0]
                                ? Object.entries(
                                    infoJobData.commands[0]
                                  ).map(([key, value]) =>
                                    renderKeyValue(
                                      key,
                                      value
                                    )
                                  )
                                : null
                            }
                            arrow
                            placement="bottom"
                          >
                            <StyledIconButton colors={colors}>
                              <InfoOutlinedIcon fontSize="18" />
                            </StyledIconButton>
                          </Tooltip>
                        </Box>
                      )}
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3.5}
                  md={2}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    flexDirection={"column"}
                    display={"flex"}
                    alignItems={"flex-start"}
                  >
                    <H8TitleMedium>Status</H8TitleMedium>
                    <Box
                      flexDirection={"column"}
                      display={"flex"}
                    >
                      <BodyMedium>
                        {infoJobData && infoJobData.status
                          ? `${capitalizeString(
                              infoJobData.status
                            )}`
                          : ""}
                      </BodyMedium>
                      <BodyMedium>
                        {infoJobData &&
                        infoJobData.serialsActiveCount !==
                          undefined &&
                        infoJobData.serialsActiveCount !==
                          null &&
                        infoJobData.serialsActiveCount !==
                          "" &&
                        infoJobData.serialsCount !==
                          undefined &&
                        infoJobData.serialsCount !== null &&
                        infoJobData.serialsCount !== "" ? (
                          <>
                            <span
                              style={{ fontWeight: 525 }}
                            >
                              Miners Connected:
                            </span>{" "}
                            {infoJobData.serialsActiveCount}
                            /{infoJobData.serialsCount}
                          </>
                        ) : null}
                      </BodyMedium>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3.5}
                  md={2}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    flexDirection={"column"}
                    display={"flex"}
                    alignItems={"flex-start"}
                    flexGrow={1}
                  >
                    <H8TitleMedium>Site</H8TitleMedium>
                    <Box
                      display={"flex"}
                      flexGrow={1}
                      flexShrink={1}
                      width={"100%"}
                      maxWidth={{
                        xs: "14rem",
                        sm: "14rem",
                        md: "16rem",
                        lg: "18rem",
                        xl: "20rem",
                      }}
                    >
                      <BodyMedium noWrap>
                        {infoJobData && infoJobData.siteName
                          ? infoJobData.siteName
                          : ""}
                      </BodyMedium>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={3}
                  sm={3.5}
                  md={1.6}
                  lg={1.6}
                  xl={1.6}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-start"}
                  >
                    <H8TitleMedium>User</H8TitleMedium>
                    <Box
                      display={"flex"}
                      flexGrow={1}
                      flexShrink={1}
                      width={"100%"}
                      maxWidth={{
                        xs: "14rem",
                        sm: "14rem",
                        md: "16rem",
                        lg: "18rem",
                        xl: "20rem",
                      }}
                    >
                      <BodyMedium noWrap>
                        {infoJobData && infoJobData.email
                          ? infoJobData.email
                          : ""}
                      </BodyMedium>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid
          ref={tableContainerRef}
          item
          xs={12}
          sx={{
            transition: "width 0.3s ease-in-out", // Smooth transition for width
          }}
        >
          <Box
            className={"miner-page-table"}
            display={"flex"}
            flexDirection={"row"}
            backgroundColor={colors?.background?.paper}
            padding={"0.75rem 0  0.75rem 0"}
            borderRadius={"1rem"}
            sx={{
              transition: "width 0.3s ease-in-out", // Smooth transition for width
            }}
          >
            <Box
              className={"table-container"}
              display={"flex"}
              flexDirection={"column"}
              padding={"0 0.75rem 0 0.75rem"}
              height={"auto"}
              // overflow={"auto"}
              minWidth={"0"}
              gap={4}
              flex={3}
              flexShrink={1}
            >
              <IndividualJobsPageHeader
                selectedGroups={selectedGroups}
                setSelectedGroups={setSelectedGroups}
                siteGroups={siteGroups}
                onSearchChange={onSearchChange}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                setDsearchValue={setDsearchValue}
              />

              <Box
                className={"Datagrid-container"}
                display={"flex"}
                flexShrink={1}
                flexGrow={1}
                height="calc(100vh - 25rem)"
              >
                <DataGrid
                  colors={colors}
                  config={dataGridProps}
                  height="calc(100vh - 25rem)"
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </PageWrapper>
  );
}

export default function IndividualJobsPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <PoolsPageContextProvider>
        <IndividualJobsPageContent />
      </PoolsPageContextProvider>
    </QueryClientProvider>
  );
}
